import { SUBSCRIPTIONS_API_KEYS } from "features/MySubscriptions/constants/MySubscriptions.constants";
import {
  getDiscount,
  getPlanByRecurrenceMonths,
  getTenureOptionsFromSubscriptionPlans,
} from "features/MySubscriptions/utils/tenure.utils";

export const sortSubscriptionPlansByPriority = (plans = []) => {
  if (!Array.isArray(plans)) return [];

  return [...plans]
    .filter((plan) => plan && typeof plan === "object")
    .sort((a, b) => {
      const priorityA = Number(a[SUBSCRIPTIONS_API_KEYS.priority]) || 0;
      const priorityB = Number(b[SUBSCRIPTIONS_API_KEYS.priority]) || 0;
      return priorityA - priorityB;
    });
};

export const getOverallLicensesDiscount = (plans) => {
  const tenureOptions = getTenureOptionsFromSubscriptionPlans(plans, {
    consumableOnly: true,
  });

  if (tenureOptions.length < 2) return 0;

  const baseOption = tenureOptions?.[0];
  const longestOption = tenureOptions[tenureOptions.length - 1];
  let totalPerMonthAtBaseRate = 0;
  let totalBundlePrice = 0;

  plans.forEach((feature) => {
    if (feature[SUBSCRIPTIONS_API_KEYS.is_access_type]) return;

    const featurePlans = feature[SUBSCRIPTIONS_API_KEYS.plans] ?? [];
    const basePlan = getPlanByRecurrenceMonths(featurePlans, baseOption.value);
    const longestPlan = getPlanByRecurrenceMonths(
      featurePlans,
      longestOption.value
    );

    if (basePlan) {
      totalPerMonthAtBaseRate +=
        (basePlan[SUBSCRIPTIONS_API_KEYS.default_price] ?? 0) /
        baseOption.value;
    }

    if (longestPlan) {
      totalBundlePrice +=
        longestPlan[SUBSCRIPTIONS_API_KEYS.default_price] ?? 0;
    }
  });

  return getDiscount({
    monthlyPrice: totalPerMonthAtBaseRate,
    planPrice: totalBundlePrice,
    planTenure: longestOption.value,
  });
};

export const getPlan = ({ featureKey, plans }) => {
  return plans.find(
    (plan) => plan[SUBSCRIPTIONS_API_KEYS.feature_key] === featureKey
  );
};

export const getTenurePlan = ({ featureKey, plans, tenure }) => {
  const selectedPlan = getPlan({ featureKey, plans });
  const { [SUBSCRIPTIONS_API_KEYS.plans]: tenurePlans } = selectedPlan ?? {};

  return getPlanByRecurrenceMonths(tenurePlans, tenure);
};
